import { BUILD_DATE } from "~/env";

const REFERRER_STORAGE_KEY = "STS_BROWSER_COMPAT_REFERRER";
const COMPAT_VERSION_STORAGE_KEY = "STS_IS_BROWSER_COMPATIBLE";
const COMPAT_VERSION_SEARCH_PARAM = "v";

const COMPAT_VERSION = BUILD_DATE;

const isCompatibleWith = (version: string) => localStorage.getItem(COMPAT_VERSION_STORAGE_KEY) === version;

export const isCompatible = (): boolean => isCompatibleWith(COMPAT_VERSION);

export const navigateToBrowserCompat = (referrer: string): void => {
	sessionStorage.setItem(REFERRER_STORAGE_KEY, referrer);
	location.replace(`browser_compat/check.html?${COMPAT_VERSION_SEARCH_PARAM}=${COMPAT_VERSION}`);
};

export const navigateToReferrer = (fallback: VoidFunction): void => {
	// the version comes from the query parameter to avoid using localStorage as a source of truth
	const compatVersion = new URLSearchParams(location.search).get(COMPAT_VERSION_SEARCH_PARAM);
	const referrer = sessionStorage.getItem(REFERRER_STORAGE_KEY);

	// if the browser is already compatible, we don't need to redirect to avoid a potential redirect loop
	if (!(referrer && compatVersion) || isCompatibleWith(compatVersion)) {
		fallback();
	} else {
		localStorage.setItem(COMPAT_VERSION_STORAGE_KEY, compatVersion);
		sessionStorage.removeItem(REFERRER_STORAGE_KEY);
		location.replace(referrer);
	}
};
